export default {
  methods: {
    getS3Photo(path, file_name, width, height, quality, watermarked) {
      if (!path || !file_name) {
        return '/images/photo-not-found.jpg'; // Add a default image
      }
      
      const imageRequest = JSON.stringify({
        bucket: process.env.VUE_APP_AWS_S3_MAIN_BUCKET,
        key: watermarked
          ? "watermark/" + path + "/" + file_name
          : "originals/" + path + "/" + file_name,
        edits: {
          resize: {
            width: width,
            height: height,
            fit: "inside",
          },
        },
        filters: "quality(" + quality + ")",
      });
      
      return process.env.VUE_APP_CLOUDFRONT_ENDPOINT + "/" + btoa(imageRequest);
    },
    
    handleImageError(event) {
      event.target.src = '/images/photo-not-found.jpg';
    }
  }
};
